import type { Attribute, JSONContent } from '@tiptap/core'

// =============== Document

interface EmptyParagraphBlock extends JSONContent {
  type: 'paragraph'
}

export const EMPTY_PARAGRAPH_HTML = '<p></p>' as const

export const EMPTY_PARAGRAPH_JSON = {
  type: 'paragraph',
} as const satisfies EmptyParagraphBlock

// =============== Extensions

export type NodeAttributes<T> = Record<keyof T, Attribute>
